require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-brand-building-ecommerce.json") })
        }
      }, "path---tapd-in-brand-building-ecommerce");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-brand-building-ecommerce!./.cache/json/tapd-in-brand-building-ecommerce.json
// module id = 812
// module chunks = 231608221292675